import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-agent-modal',
  templateUrl: './create-agent-modal.component.html',
  styleUrls: ['./create-agent-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class CreateAgentModalComponent {
  agentForm: FormGroup;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) {
    this.agentForm = this.fb.group({
      name: ['', Validators.required],
      instructions: ['', Validators.required],
      apps: [[]],
    });
  }

  onSubmit() {
    if (this.agentForm.valid) {
      this.activeModal.close(this.agentForm.value);
    }
  }
}
